import * as d3 from 'd3';
import { SLOT_TIME } from '../utils/constants.js';

export default class SlotProgressUI {
    static TRANSITION_DURATION = 1000

    constructor(element) {
        this.padding = { top: 20, right: 0, bottom: 0, left: 0 };
        var parentDiv = document.querySelector(element); // Replace with the ID of your parent div
        var rect = parentDiv.getBoundingClientRect();
        this.height = rect.height;
        this.width = rect.width;
        this.segmentWidth = (this.width - this.padding.left - this.padding.right) / SLOT_TIME

        this.svg = d3.select(element).append("svg")
            .attr("preserveAspectRatio", "xMinYMin meet")
            .attr("viewBox", `0 0 ${this.width} ${this.height}`)

        this.xScale = d3.scaleBand()
            .domain(d3.range(SLOT_TIME))
            .range([this.padding.left, this.width - this.padding.right]);

        this.progress = this.svg.append('rect')
            .attr('x', this.padding.left)
            .attr('y', this.padding.top)
            .attr('width', this.padding.left)
            .attr('height', this.height - this.padding.top - this.padding.bottom)
            .attr('fill', "#26a6ed");

        this.xAxis = d3.axisBottom(this.xScale)
            .tickSizeOuter(0)
            .tickSizeInner((this.height - this.padding.top - this.padding.bottom))
            .tickValues([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]) // Set the tick values here
            .tickFormat(d3.format("d")); // Format the tick values as desired

        const bandwidth = this.xScale.bandwidth();
        const offset = bandwidth / 2; // Calculate the offset

        //this.xAxisGroup = this.svg.append('g')
        this.xAxisGroup = this.svg.append('g')
            .attr('class', 'x-axis')
            .attr('transform', `translate(${-offset}, ${this.padding.top})`)
            .call(this.xAxis)
            .selectAll('.tick line') // Select all the tick lines
            .attr('stroke-width', 1); // Set the stroke width for tick lines

        this.xAxisGroup.selectAll('.domain').remove(); // Remove the domain and tick lines

        this.svg.append('line')
            .attr('x1', this.padding.left)
            .attr('y1', this.padding.top)
            .attr('x2', this.width - this.padding.right)
            .attr('y2', this.padding.top)
            .attr('stroke', '#d3d3d3')
            .attr('stroke-width', 2);

        this.svg.append('line')
            .attr('x1', this.padding.left)
            .attr('y1', this.height - this.padding.bottom)
            .attr('x2', this.width - this.padding.right)
            .attr('y2', this.height - this.padding.bottom)
            .attr('stroke', '#d3d3d3')
            .attr('stroke-width', 2);

        this.svg.append('line')
            .attr('x1', this.padding.left)
            .attr('y1', this.padding.top)
            .attr('x2', this.padding.left)
            .attr('y2', this.height - this.padding.bottom)
            .attr('stroke', '#d3d3d3')
            .attr('stroke-width', 2);

        this.svg.append('line')
            .attr('x1', this.width - this.padding.right)
            .attr('y1', this.padding.top)
            .attr('x2', this.width - this.padding.right)
            .attr('y2', this.height - this.padding.bottom)
            .attr('stroke', '#d3d3d3')
            .attr('stroke-width', 2);

    }

    setBlockInfo = (block_info) => {
        this.block_info = block_info
        this.updateLabel(block_info.slot)
        this.updateProgress(SLOT_TIME + 1)

        this.svg.on('click', (event) => {
            const clickY = event.clientY - this.svg.node().getBoundingClientRect().top;

            if (clickY <= this.padding.top) {
                this.updateProgress(SLOT_TIME + 1)
                if (this.block_info.submissions.length > 0) {
                    var submission = this.block_info.submissions[this.block_info.submissions.length - 1]
                    this.block_bid_ui?.setBuilderMap(submission.best_by_builder, submission.bids_by_relay)
                }
            } else if (clickY > this.height / 2) {
                const clickX = event.clientX - this.svg.node().getBoundingClientRect().left;
                const clickedSecond = Math.ceil(clickX / this.segmentWidth);
                this.updateProgress(clickedSecond)
                this.block_info.submissions.forEach(submission => {
                    let x = submission.timestamp - submission.block_timestamp // timestamp are in millisecond precision
                    if (x > SLOT_TIME + 1) {
                        x = SLOT_TIME + 1
                    }
                    if (x === clickedSecond) {
                        this.block_bid_ui?.setBuilderMap(submission.best_by_builder, submission.bids_by_relay)
                    }
                });
            }
        })

        this.svg.style("cursor", "pointer")
    }

    setProgress = (second) => {
        this.updateProgress(second)
    }

    setBlockBidUI = (block_bid) => {
        this.block_bid_ui = block_bid
    }

    newBlockSummary = (block_summary) => {
        //this.reference_time = block_summary.timestamp / 1e9
        //this.updateLabel(block_summary.slot)
    }

    newPoolSummary = (pool_summary) => {
        //console.log(pool_summary)
        this.updateLabel(pool_summary.slot)
        const currentTimeUnix = Math.floor(Date.now() / 1000);
        var second = currentTimeUnix - (pool_summary.slot_timestamp - 12)
        if (second > 0) {
            this.updateProgress(second)
        }
    }

    updateProgress = (second) => {
        this.progress = this.svg.selectAll('rect')
            .transition()
            .duration(SlotProgressUI.TRANSITION_DURATION)
            .attr('width', this.segmentWidth * Math.min(second, SLOT_TIME))
            .attr('fill', () => {
                if (second > SLOT_TIME) {
                    // Use a darker color if the second is higher than SLOT_TIME
                    return d3.rgb('#26a6ed').darker();
                } else {
                    return '#26a6ed';
                }
            })
            .attr('rx', 2) // Set the horizontal radius for rounded corners
            .attr('ry', 2) // Set the vertical radius for rounded corners
    }

    updateLabel = (slot) => {
        if (this.valueLabel !== undefined) {
            this.valueLabel.remove()
        }
        this.valueLabel = this.svg.append('text')
            .attr('class', 'label')
            .attr('x', this.width / 2)
            .attr('y', 12)
            .attr('text-anchor', 'middle')
            .style("font-family", "Courier,Courier New,slab-serif")
            .style("font-weight", "bold")
            .style('font-size', '16px')
            .style('fill', '#d3d3d3')
            .text(`Epoch ${Math.floor(slot / 32)} / Slot ${slot}`);
    }

}